module.exports = __webpack_public_path__ + "static/media/AB_P7_3.4377bb54.jpg";